import { v4 as uuidv4 } from 'uuid';

const inputTypes = [
    {
        id: uuidv4(),
        page: "login",
        inputType: "text",
        placeholder: "Enter Your E-Mail or Phone number",
        inputId: "passwordInput",
        ifRequired: true,
        labelTitle: "Email Or Phone",
    },
    {
        id: uuidv4(),
        page: "login",
        inputType: "password",
        placeholder: "Email Or Phone",
        inputId: "emailInput",
        ifRequired: true,
        labelTitle: "Password",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "text",
        placeholder: "Enter Your First Name",
        inputId: "fNameInput",
        ifRequired: true,
        labelTitle: "First Name",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "text",
        placeholder: "Enter Your Last Name",
        inputId: "lNameInput",
        ifRequired: true,
        labelTitle: "Last Name",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "text",
        placeholder: "Enter Your Phone Number",
        inputId: "phoneNumInput",
        ifRequired: true,
        labelTitle: "Phone Number",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "email",
        placeholder: "Enter Your E-mail",
        inputId: "emailInput",
        ifRequired: true,
        labelTitle: "E-mail",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "password",
        placeholder: "Enter Your Password",
        inputId: "passwordInput",
        ifRequired: true,
        labelTitle: "Password",
    },
    {
        id: uuidv4(),
        page: "register",
        inputType: "password",
        placeholder: "Confirm Your Password",
        inputId: "confPasswordInput",
        ifRequired: true,
        labelTitle: "Confirm Your Password",
    },
    {
        id: uuidv4(),
        page: "forget",
        inputType: "text",
        placeholder: "Enter Your E-Mail or Phone number",
        inputId: "passwordInput",
        ifRequired: true,
        labelTitle: "Email Or Phone",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Name",
        inputId: "nameInput",
        ifRequired: true,
        labelTitle: "Name",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "email",
        placeholder: "Enter Your E-mail",
        inputId: "emailInput",
        ifRequired: true,
        labelTitle: "E-mail",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Job Title",
        inputId: "jobTitle",
        ifRequired: false,
        labelTitle: "Job Title",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Fax",
        inputId: "fax",
        ifRequired: false,
        labelTitle: "Fax",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Phone Number",
        inputId: "phoneNumInput",
        ifRequired: true,
        labelTitle: "Phone",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Company Name",
        inputId: "companyName",
        ifRequired: false,
        labelTitle: "Company Name",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Telephone Number",
        inputId: "telephoneNumInput",
        ifRequired: false,
        labelTitle: "Telephone Number",
    },
    {
        id: uuidv4(),
        page: "contact",
        inputType: "text",
        placeholder: "Enter Your Country",
        inputId: "country",
        ifRequired: false,
        labelTitle: "Country",
    },
];

export default inputTypes;